import React from "react";
import MasterLayout from "../../../../masterLayout/MasterLayout";
import Breadcrumb from "../../../../components/Breadcrumb";
import Approved from "./Approved";

const ApprovedLayout = () => {
  return (
    <MasterLayout>
      <Breadcrumb title="Approved Counselors" />
      <Approved url={"counselors/approved"} />
    </MasterLayout>
  );
};

export default ApprovedLayout;
